import React from 'react';

import styles from './style.scss';


const TrialCardHeaderItem = ({ imageStyleName, children, className }) => (
  <div className={className ? `${className} ${styles.headerItem}` : styles.headerItem}>
    {imageStyleName && (
      <i className={imageStyleName} />
    )}
    <div className={styles.headerItemTitle}>
      {children}
    </div>
  </div>
);

export default TrialCardHeaderItem;
